import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StakeholderRoutingModule } from './stakeholder-routing.module';
import { StakeholderContainerComponent } from './containers/stakeholder-container/stakeholder-container.component';
import { RouterModule } from '@angular/router';

import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';

import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { StoreModule } from '@ngrx/store';

import * as fromStakeholder from './states/+stakeholder/stakeholder.reducer';
import { StakeholderEffects } from './states/+stakeholder/stakeholder.effects';

import { StakeholderFacade } from './states/+stakeholder/stakeholder.facade';
import { EffectsModule } from '@ngrx/effects';
import { StakeholdersearchComponent } from './containers/stakeholder-container/stakeholdersearch/stakeholdersearch.component';
import { DocumentoperationsModule } from './../../../documentoperations/src/lib/documentoperations.module';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    StoreModule.forFeature(
      fromStakeholder.STAKEHOLDER_FEATURE_KEY,
      fromStakeholder.reducer
    ),
    EffectsModule.forFeature([StakeholderEffects]),
    StakeholderRoutingModule,
    DocumentoperationsModule,
  ],
  declarations: [StakeholderContainerComponent, StakeholdersearchComponent],
  providers: [StakeholderFacade],
  entryComponents: [],
})
export class StakeholderModule {}
